import React, { useEffect,  useState } from 'react'
import styled from 'styled-components';
import logo from '../../../assets/images/logo.png';
import logo2 from '../../../assets/images/logo2.png';
import { RowTypeSpaceBetween } from '../../genericComponents/Layouts';
import ShadowCard from '../../genericComponents/ShadowCard';
import Text from '../../genericComponents/Text';
import { PrymaryButton } from '../../genericComponents/Button';
import { CloudDownloadOutlined, ControlOutlined, InfoCircleOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import {useTranslation} from 'react-i18next'; 
import { THEME } from '../../genericComponents/globalStyles';
import { Spin, Tooltip } from 'antd';
import MyHeatMAp from './MyHeatMap';
import MyBarChart from './MyBarChart';
import PrintArea from './PrintArea';
import EquipmentListModal from './EquipmentListModal';
import PdfNameModal from './PdfNameModal';
import axios from 'axios';
import { getQueryVariable, getQueryVariablesList } from '../../../helpers/queryhandler';
const urlImage = 'https://media.equipson.es/img/WEB/';

export default function ResultBody({
  setIsModalVisible,
  simulationData,
  simulationLoading,
  productsJson,
  manualSelectedAmplifier,
  recommendedAmplifier,
  setRecommendedAmplifier,
  printing,
  setPrinting
}){
  const { t } = useTranslation();
  const langSelected = localStorage.getItem("i18nextLng") || "en";
  const [printNameModalShow, setPrintNameModalShow] = useState(false)
  const [equipmentListModalShow, setEquipmentListModalShow] = useState(false);
  const [pdfName, setPdfName] = useState('');
  const [session] = useState(getQueryVariable('isLoggedIn'))
  const [project] = useState(getQueryVariable('project'));

  useEffect(() => {
    if(simulationData?.power&&simulationData?.speakerNumt&&simulationData?.speaker?.autoAmplified!=="1"&&simulationData?.typePower!=="lowImpedance"){
      const powerRequired = Number(simulationData.power)*Number.parseInt(simulationData.speakerNumt||0)*1.2;

      let newRecommendedAmplifier = productsJson?.amplifiers?.find(r=>Number(r.power)>=powerRequired && r[simulationData?.typePower]==='1');
      if(!newRecommendedAmplifier)newRecommendedAmplifier=productsJson?.amplifiers[productsJson?.amplifiers?.length-1];
      setRecommendedAmplifier({
        amplifier:newRecommendedAmplifier,
        quantity:Math.ceil((Number(simulationData.power)*Number.parseInt(simulationData.speakerNumt||0)*1.2)/Number(newRecommendedAmplifier?.power))
      })
    }else{
      setRecommendedAmplifier(null)
    }
  }, [simulationData?.power,simulationData?.speakerNumt,simulationData?.typePower]);

  async function handleBuyProducts() {
    
    const session = getQueryVariable('isLoggedIn');
    if(session!=='true')return alert(t('you_must_be_logged_into_execute_this_action'))

    const products = [{
      id:simulationData?.speaker?.idProduct,
      quantity:Number.parseInt(simulationData?.speakerNumt||1)
    }];

    const showAmplifier = manualSelectedAmplifier?manualSelectedAmplifier:recommendedAmplifier;

    if(showAmplifier){
      products.push({
        id: showAmplifier?.amplifier?.idProduct,
        quantity:showAmplifier?.quantity
      })
    }

    const arrayVars = getQueryVariablesList()

    var params = new URLSearchParams();
    params.append('setACProducts', JSON.stringify(products));
    arrayVars.forEach(r=>params.append(r.key,r.value));
    const result = await axios.post('https://media.equipson.es/setAcSimCart.php', params); 
    console.log(result)
  }

  const showAmplifier = manualSelectedAmplifier?manualSelectedAmplifier:recommendedAmplifier;
  const speakerslogan = (langSelected==='es'?simulationData?.speaker?.slogan_100:simulationData?.speaker?.slogan_101)?.split('. ');
  const amplifierSlogan = (langSelected==='es'?showAmplifier?.amplifier?.slogan_100:showAmplifier?.amplifier?.slogan_101)?.split('. ');
  if(amplifierSlogan?.length){
    const last =amplifierSlogan.length-1
    amplifierSlogan[last]=amplifierSlogan[last].endsWith('.')?amplifierSlogan[last].substring(0,amplifierSlogan[last].length-1):null;
  }
  if(speakerslogan?.length){
    const last =speakerslogan.length-1
    speakerslogan[last]=speakerslogan[last].endsWith('.')?speakerslogan[last].substring(0,speakerslogan[last].length-1):null;
  }
  

  return (
    <Body>
      {simulationLoading?
        <LogoCont>
          <Spin size="large" />
        </LogoCont>
      :
        printing?
          <PrintArea 
            printing={printing}
            setPrinting={setPrinting}
            pdfName={pdfName}
            simulationData={simulationData}
            showAmplifier={showAmplifier}
            amplifier={{
              name:showAmplifier?.amplifier?.name,
              quantity:showAmplifier?.quantity
            }}
            speaker={{
              name:simulationData?.speaker?.speakerName,
              quantity:Number.parseInt(simulationData?.speakerNumt||0)
            }}
          />
        :
        simulationData?(
          <div>
            <ShadowCard>
              <RowTypeSpaceBetween>
                <div>
                  <Text titleSize={3} titleLevel={4}>{t('speakers')}</Text>
                  <Text titleSize={2} titleLevel={4}>
                    {t('model')}: <strong>{simulationData?.speaker?.speakerName}</strong>
                  </Text>
                  <Text titleSize={2} titleLevel={3}>
                    {speakerslogan&&speakerslogan[0]}
                  </Text>
                  <br/>
                  <Text titleLevel={4} strong>{t('characteristics')}</Text>
                  {speakerslogan.slice(1).map((f,i)=>
                    <Text key={i} titleLevel={4}>• {f}.</Text>
                  )}
                </div>
                <div>
                  <img 
                    alt=""
                    width={220}
                    src={urlImage+simulationData?.speaker?.media?.find(m=>m.mediaOrder==="0").path} 
                  />
                </div>
                <VerticalSpaceBetween>
                  <img
                    alt=""
                    width={100}
                    src={simulationData?.speaker?.brandlogo} 
                  />
                  <PrymaryButton onClick={()=>window.open(simulationData?.speaker?.path)} style={{maxWidth:200}}>
                    {t('see_product')}
                  </PrymaryButton>
                </VerticalSpaceBetween>
              </RowTypeSpaceBetween>
            </ShadowCard>

            <ShadowCard>
              <Tooltip title={t('spl_output_tooltip_text')} placement="bottom" color={THEME.colors.blue}>
                <Text titleSize={3} titleLevel={4} style={{width:'fit-content'}}>
                  {t('sound_preasure_distribution')}
                  <InfoCircleOutlined style={{fontSize:20,color:THEME.colors.blue,paddingLeft:12}} />
                </Text>
              </Tooltip>
              <br/>
              <MyHeatMAp printing={printing} simulationData={simulationData} t={t}/>
            </ShadowCard>

            <ShadowCard>
              <Tooltip title={t('spl_distribution_tooltip_text')} placement="bottom" color={THEME.colors.blue}>
                <Text titleSize={3} titleLevel={4} style={{width:'fit-content'}}>
                  {t('spl_distribution')}
                  <InfoCircleOutlined style={{fontSize:20,color:THEME.colors.blue,paddingLeft:12}} />
                </Text>
              </Tooltip>
              <br/>
              <MyBarChart printing={printing} simulationData={simulationData} t={t}/>
            </ShadowCard>

            <ShadowCard>
              <Text titleSize={3} titleLevel={4}>{t('recommendations')}</Text>
              <RowTypeSpaceBetween>
                <div/>
                <div style={{textAlign:'center'}}>
                  <Text titleSize={1} titleLevel={4}>{t('total_number_of_speakers')}</Text>
                  <br/>
                  <Text titleSize={3} titleLevel={4}>
                    {Number.parseInt(simulationData.speakerNumt||0)} {t('units')}
                  </Text>
                </div>
                <div style={{textAlign:'center'}}>
                  <Text titleSize={1} titleLevel={4}>{t('total_power_consumed')}</Text>
                  <br/>
                  <Text titleSize={3} titleLevel={4}>
                    {Number(simulationData.power)*Number.parseInt(simulationData.speakerNumt||0)} W
                  </Text>
                </div>
                {simulationData?.speaker?.autoAmplified!=="1"?
                  <div style={{textAlign:'center'}}>
                    <Text titleSize={1} titleLevel={4}>{t('minimum_amplifier_power')}</Text>
                    <br/>
                    <Text titleSize={3} titleLevel={4}>
                      {parseFloat((Number(simulationData.power)*Number.parseInt(simulationData.speakerNumt||0)*1.2).toFixed(2))} W
                    </Text>
                    <Text titleSize={1} titleLevel={4}>(20% {t('over_total_power')})</Text>
                  </div>
                :
                  null
                }
                <div/>
              </RowTypeSpaceBetween>
            </ShadowCard>
            {simulationData?.speaker?.autoAmplified!=="1"?
              <ShadowCard>
                {simulationData?.typePower==="lowImpedance"&&!showAmplifier?
                  <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                    <Text titleSize={3} titleLevel={4}>{t('amplifiers')}</Text>
                    <BlueAlert>
                      <Text titleLevel={3}>{t('the_number_of_amplifiers_to_be_include')}</Text>
                    </BlueAlert>
                    <br/>
                    <PrymaryButton style={{width:'fit-content'}} secondary onClick={()=>setIsModalVisible(true)}>
                      {t('Select_low_impedance_amplifier')}
                    </PrymaryButton>
                  </div>
                :
                  <RowTypeSpaceBetween>
                    <div>
                      <Text titleSize={3} titleLevel={4}>{t('amplifiers')}</Text>
                      <div style={{display:'flex',alignItems:'center'}}>
                        <QuantityCircle>
                          <Text titleSize={2} titleLevel={3} strong>{showAmplifier?.quantity}x</Text>
                        </QuantityCircle>
                        <Text titleSize={2} titleLevel={4}>{t('model')}: <strong>{showAmplifier?.amplifier?.name}</strong></Text>
                      </div>
                      <Text titleSize={2} titleLevel={3}>
                        {amplifierSlogan&&amplifierSlogan[0]}
                      </Text>
                      <br/>
                      <Text titleLevel={4}>{t('recommended_amplifier')}</Text>
                      <Text titleLevel={4} strong>{t('characteristics')}</Text>
                      {amplifierSlogan.slice(1).map((r,i)=>
                        <Text key={i} titleLevel={4}>• {r}.</Text>
                      )}
                    </div>
                    <div>
                      <img 
                        alt=""
                        style={{marginLeft:24,marginRight:-48}}
                        width={220}
                        src={urlImage+showAmplifier?.amplifier?.media.find(m=>m.mediaOrder==="0").path} 
                      />
                    </div>
                    <VerticalSpaceBetween>
                      <img 
                        alt=""
                        width={100}
                        src={showAmplifier?.amplifier?.brandlogo} 
                      />
                      <PrymaryButton onClick={()=>window.open(showAmplifier?.amplifier?.path)} style={{width:160}}>
                        {t('see_product')}
                      </PrymaryButton>
                      <PrymaryButton style={{minWidth:250,maxWidth:300}} secondary onClick={()=>setIsModalVisible(true)}>
                        {t('select_another_amplifier')}
                      </PrymaryButton>
                    </VerticalSpaceBetween>
                  </RowTypeSpaceBetween>
                }
              </ShadowCard>
            :
              null
            }
            <RowTypeSpaceBetween >
              <div style={{width:30}}/>
              <PrymaryButton style={{flex:1,minWidth:250}} onClick={()=>setEquipmentListModalShow(true)}>
                <ControlOutlined style={{marginRight:8, fontSize:18}} />
                {t('equipment_list')}
              </PrymaryButton>
              <div style={{width:30}}/>
              <PrymaryButton style={{flex:1,minWidth:250}} onClick={()=>setPrintNameModalShow(true)}>
                <CloudDownloadOutlined style={{marginRight:8, fontSize:18}} /> 
                {t('download_simulation')}
              </PrymaryButton>
              {session==='true'&&(
                <>
                  <div style={{width:30}}/>
                  <PrymaryButton onClick={handleBuyProducts} style={{flex:1,minWidth:250}}>
                    <ShoppingCartOutlined style={{marginRight:8, fontSize:18}} /> 
                    {t('buy_in_store')}
                  </PrymaryButton>
                </>
              )}
              <div style={{width:30}}/>
            </RowTypeSpaceBetween>
          </div>
        ):
          <LogoCont>
            <Logo src={project==='workpro'?logo2:logo} />
          </LogoCont>
      }
      <EquipmentListModal
        isModalVisible={equipmentListModalShow}
        setIsModalVisible={setEquipmentListModalShow}
        showAmplifier={simulationData?.speaker?.autoAmplified!=="1"}
        amplifier={{
          name:showAmplifier?.amplifier?.name,
          quantity:showAmplifier?.quantity
        }}
        speaker={{
          name:simulationData?.speaker?.speakerName,
          quantity:Number.parseInt(simulationData?.speakerNumt||0)
        }}
      />
      <PdfNameModal
        isModalVisible={printNameModalShow}
        setIsModalVisible={setPrintNameModalShow}
        pdfName={pdfName}
        printing={printing}
        setPdfName={setPdfName}
        setPrinting={setPrinting}
      />
    </Body>
  )
}

const Body = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: column;
  padding-left: 24px;
  position: relative;
  @media (max-width: 1337px) {
    max-width: 920px;
    align-self: center;
    padding-left: 0;
  }
  @media (max-width: 900px) {
    align-self: flex-start;
  }
`;
const VerticalSpaceBetween = styled.div`
  display: flex;
  flex:1;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
`;
const LogoCont = styled.div`
  position: absolute;
  display: flex;
  width: 95%;
  height:600px;
  justify-content: center;
  align-items: center;
  z-index: 0;
  @media (max-width: 1337px) {
    height:300px;
  }
`;
const Logo = styled.img`
  width: 500px;
  height: 150px;
  opacity: 0.3;
`;
const BlueAlert = styled.div`
  background: ${THEME.colors.ligthBlue};
  border-radius: 20px;
  padding: 6px 16px 4px 16px;
`;
const QuantityCircle = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 4px 0 4px;
  border: 1px solid ${THEME.colors.blue};
  border-radius: 50px;
  margin-right: 6px;
`;